import { useState, useEffect } from "react";

const API = process.env.REACT_APP_API_URL;

export function useOrigamiReboot({ code, playerId }) {
  const [showOrigamiReboot, setShowOrigamiReboot] = useState(false);

  useEffect(() => {
    if (!code || !playerId) return;

    const checkReboot = async () => {
      try {
        // Utiliser l'endpoint existant
        const response = await fetch(`${API}/api/sessions/${code}`);
        const state = await response.json();

        // Vérifier si le reboot est activé ET si ce joueur ne l'a pas déjà vu
        const shownPlayers = Array.isArray(state.origamiRebootShownPlayers)
          ? state.origamiRebootShownPlayers
          : [];

        if (state.origamiRebooted && !shownPlayers.includes(Number(playerId))) {
          setShowOrigamiReboot(true);

          // Marquer comme vu côté serveur
          await fetch(`${API}/api/sessions/${code}/origami-reboot-seen`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ playerId: Number(playerId) }),
          });
        }
      } catch (error) {
        console.error("Error checking origami reboot:", error);
      }
    };

    // Poll toutes les 3 secondes
    const interval = setInterval(checkReboot, 3000);

    // Check immédiatement au montage
    checkReboot();

    return () => clearInterval(interval);
  }, [code, playerId]);

  return { showOrigamiReboot, setShowOrigamiReboot };
}